// removed by extract-text-webpack-plugin
module.exports = {"PhotogalleryLayout":"PhotogalleryLayout","PhotogalleryLayout__td":"PhotogalleryLayout__td","PhotogalleryLayout__td2":"PhotogalleryLayout__td2","PhotogalleryLayout__td3":"PhotogalleryLayout__td3","PhotogalleryLayout__td4":"PhotogalleryLayout__td4","PhotogalleryLayout__box":"PhotogalleryLayout__box","PhotogalleryLayout__box2":"PhotogalleryLayout__box2"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/photogallery-layout/styles.css
// module id = 815
// module chunks = 0 1